// extracted by mini-css-extract-plugin
export var container = "_ae-0";
export var fallback = "_ae-5";
export var fallbackIcon = "_ae-6";
export var hidden = "_ae-2";
export var image = "_ae-3";
export var loaded = "_ae-4";
export var placeholder = "_ae-1";